import { InputLabel, Select, MenuItem } from "@mui/material";

export function IaxDeptSelector({
  uslabelid,
  uslabel,
  usvalue,
  usonchange,
  deptosdto,
  usrequired,
}) {
  return (
    <>
      <InputLabel id={uslabelid}>{uslabel}</InputLabel>
      <Select
        labelId={uslabelid}
        value={usvalue}
        variant="filled"
        InputLabelProps={{ shrink: true }}
        fullWidth
        sx={{ mb: 4 }}
        label={uslabel}
        onChange={usonchange}
        required={usrequired}
      >
        {deptosdto != null ? (
          deptosdto.map((depto) => (
            <MenuItem value={depto.id}>{depto.nombre}</MenuItem>
          ))
        ) : (
          <MenuItem value={0}>No hay departamentos</MenuItem>
        )}
      </Select>
    </>
  );
}
